import styled from 'styled-components';
export const Options = styled.div`
  display: flex;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  width: 18px;
`;
export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 28px;
  padding: 4px;
`;